import {
  UPDATE_AUTOPLAY_BALANCE, RUN_AUTOPLAY, SET_SPINS, SET_AUTOPLAY, DISABLE_AUTOPLAY,
  AUTOPLAY_DONE,
} from './constants'

/**
 * Propagates the RUN_AUTOPLAY event.
 * @returns {{type: string}}
 */
export function runAutoPlay() {
  return {
    type: RUN_AUTOPLAY
  }
}

/**
 * Propagates the SET_SPINS event, to set the number of Autoplay spins left.
 * @returns {{type: string, spins: number}}
 */
export function setSpins(spins) {
  return {
    type: SET_SPINS,
    spins
  }
}

/**
 * Propagates the SET_AUTOPLAY event, with information about number of
 * spins and limit values.
 * @param autoPlay
 * @returns {{type: string, autoPlay: *}}
 */
export function setAutoplay(autoPlay) {
  return {
    type: SET_AUTOPLAY,
    autoPlay
  }
}

/**
 * Propagates the event UPDATE_AUTOPLAY_BALANCE to update the autoplay balance,
 * which keeps track of money spent/earned during autoplay.
 * @returns {{type: string}}
 */
export function updateAutoplayBalance() {
  return {
    type: UPDATE_AUTOPLAY_BALANCE
  }
}

/**
 * Will propagate whether the autoplay should be disabled or not.
 * @param {boolean} disabled - If autoplay should be disabled or not.
 * @returns {{type: string, disabled: boolean}}
 */
export function disableAutoPlay(disabled) {
  return {
    type: DISABLE_AUTOPLAY,
    disabled
  }
}

export function autoPlayDone() {
  return {
    type: AUTOPLAY_DONE,
  }
}